import React from 'react';
import _ from 'lodash';

import I18n from 'app/common/i18n';
import * as enums from 'app/utils/enums';
import {history} from 'store';
import * as routePath from 'app/utils/routePath';

import {SelectField} from 'dk-ui-lib';

const handleChange = (value) => {
	history.push(`${routePath.onboardRoute}/${value}`);
}

const OnboardHeader = ({selectedOnboard, placeholder}) => {

	let options = [];

	_.map(enums.onboard_options, (value) => {
		options.push({label: value.toUpperCase(), value});
	})

	return (
		<div className='flex items-center'>
			<div className='h4 mr2 field-heading black'>{I18n.t('onboard.onboard')}</div>
			<div className='col-2'>
	      <SelectField
	        labelKey='label'
	        valueKey='value'
	        clearable={false}
	        options={options}
	        value={selectedOnboard}
	        placeholder={placeholder}
	        onChange={(value) => handleChange(value.value)} />
      </div>
		</div>
	);
}

export default OnboardHeader; 


// WEBPACK FOOTER //
// ./src/views/common/OnboardHeader.js